export const LOAD_POPULAR_DATA = 'containers/PopularPage/LOAD_POPULAR_DATA';
export const LOAD_POPULAR_DATA_SUCCESS = 'containers/PopularPage/LOAD_POPULAR_DATA_SUCCESS';
export const LOAD_POPULAR_DATA_ERROR = 'containers/PopularPage/LOAD_POPULAR_DATA_ERROR';

export const FILTER_PER_PAGE = 'containers/PopularPage/FILTER_PER_PAGE';
export const CHANGE_PAGE = 'containers/PopularPage/CHANGE_PAGE';
